import { useAuthStore } from '@/stores/auth';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { LoadingState } from './LoadingState';

export function RequireAuth({ children }: { children: ReactNode }) {
  const access = useAuthStore((s) => s.access);
  const bootstrapping = useAuthStore((s) => s.bootstrapping);
  const location = useLocation();

  if (bootstrapping) return <LoadingState />;
  if (!access) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return <>{children}</>;
}
